// Application state management

import type { AppState } from './types';

export const state: AppState = {
    products: [],
    selections: new Map(),
    customer: {
        name: '',
        email: '',
        phone: ''
    },
    errors: {}
};
